import React from 'react';
import { MdArrowForward } from 'react-icons/md';
import DynamicLink from '../DynamicLink';
import * as styles from './GlobalNav.module.styl';

const SubMenuItem = ({ subItem, isMobile = false }) => {
  if (!(subItem?.title && subItem?.link_url)) return null;

  return (
    <DynamicLink link={subItem.link_url} activeClassName={styles.active}>
      <span className={styles.subMenuItem}>
        <span className={styles.subMenuItemContent}>
          {subItem.title}
          {subItem.description ? <span>{subItem.description}</span> : null}
        </span>
        {isMobile && <MdArrowForward />}
      </span>
    </DynamicLink>
  );
};

export default SubMenuItem;
